import { render, staticRenderFns } from "./PaymentsOtrosPagos.vue?vue&type=template&id=5e8a7b7c&scoped=true&"
import script from "./PaymentsOtrosPagos.vue?vue&type=script&lang=js&"
export * from "./PaymentsOtrosPagos.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsOtrosPagos.vue?vue&type=style&index=0&id=5e8a7b7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8a7b7c",
  null
  
)

export default component.exports